angular.module('impactx.opengovernmentdata').controller('OpenGovernmentDataReadonlyDialogCtrl', [
    'dataGen',
    '$mdDialog',
    OpenGovernmentDataReadonlyDialogCtrl
]);

function OpenGovernmentDataReadonlyDialogCtrl(dataGen, $mdDialog) {
    var self = this;
    self.showAll = false;

    dataGen.getData(self, {ogdId: self.ogdId}, "/opengovernmentdata/report/readonly").then(function () {
        if (impactX.isDefined(self, 'data.orderType.setId') >= 0) {
            angular.forEach(self.data.orderType.entries, function (orderType) {
                if (orderType.value === self.data.orderType.setId) {
                    self.data.selectedOrderType = orderType.label;
                }
            });
        }
    });

    self.hide = function (answer) {
        $mdDialog.hide(answer);
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.toggleAdditionalInformation = function () {
        self.showAll = !self.showAll;
    };
}